// removed by extract-text-webpack-plugin
module.exports = {"btnsContainer":"index__btnsContainer___izMNo","floatBtn":"index__floatBtn___yQsiQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/FloatingActionButtons/index.less
// module id = 1147
// module chunks = 3